var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArhiveAltExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 25.5H38.141C37.1541 25.5 36.6607 25.5 36.2443 25.7229C35.8278 25.9457 35.5541 26.3563 35.0067 27.1774L32.9933 30.1976C32.4459 31.0187 32.1722 31.4293 31.7557 31.6521C31.3393 31.875 30.8459 31.875 29.859 31.875H21.141C20.1541 31.875 19.6607 31.875 19.2443 31.6521C18.8278 31.4293 18.5541 31.0187 18.0067 30.1976L15.9933 27.1774C15.4459 26.3563 15.1722 25.9457 14.7557 25.7229C14.3393 25.5 13.8459 25.5 12.859 25.5H6.375",
    stroke: "url(#paint0_linear_1146_2403)",
    strokeWidth: 3.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 19.125L25.5 25.5M25.5 25.5L32.9375 19.125M25.5 25.5L25.5 10.625",
    stroke: "url(#paint1_linear_1146_2403)",
    strokeWidth: 3.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 19.1248L6.92666 22.8231C6.57344 23.1763 6.375 23.6554 6.375 24.1549V36.6078C6.375 38.6882 8.06153 40.3748 10.142 40.3748H40.858C42.9385 40.3748 44.625 38.6882 44.625 36.6078V24.1549C44.625 23.6554 44.4266 23.1763 44.0733 22.8231L40.375 19.1248",
    stroke: "url(#paint2_linear_1146_2403)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_2403",
    x1: 6.375,
    y1: 28.6875,
    x2: 44.625,
    y2: 28.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_2403",
    x1: 25.5,
    y1: 25.5,
    x2: 25.5,
    y2: 10.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_2403",
    x1: 6.375,
    y1: 29.7498,
    x2: 44.625,
    y2: 29.7498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArhiveAltExport);
export default __webpack_public_path__ + "static/media/Arhive_alt_export.0c59be6c5f10d6e59f29db1a9dba95bc.svg";
export { ForwardRef as ReactComponent };